import { render } from "./ChapterPrevious.vue?vue&type=template&id=4fa8ce5c"
import script from "./ChapterPrevious.vue?vue&type=script&lang=js"
export * from "./ChapterPrevious.vue?vue&type=script&lang=js"
script.render = render

export default script